import { createHttpClient } from 'common-utils';
import { AUTH_TOKEN_KEY } from 'sso';

if (!process.env.NEXT_PUBLIC_API_BASE_URL) {
  throw new Error(
    `Unable to create preflight API client without process.env.NEXT_PUBLIC_API_BASE_URL`,
  );
}

const product = process.env.NEXT_PUBLIC_SSO_PRODUCT;
if (!product) {
  throw new Error(
    `Unable to create preflight API client without process.env.NEXT_PUBLIC_SSO_PRODUCT`,
  );
}

function getAuthToken() {
  if (typeof window !== 'undefined') {
    const authToken = localStorage.getItem(AUTH_TOKEN_KEY);
    if (authToken && authToken.length > 2) {
      return authToken;
    }
    return undefined;
  }
  return undefined;
}

function getAuthHeader(authToken?: string | null) {
  const authHeader: Partial<{ Authorization: string }> = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : {};
  return authHeader;
}

function headers(): HeadersInit {
  const authHeader = getAuthHeader(getAuthToken());
  return {
    'X-Product': product!,
    ...authHeader,
  };
}

function headersSSR(authToken: string): () => HeadersInit {
  const authHeader = getAuthHeader(authToken);
  return () => ({
    'X-Product': product!,
    ...authHeader,
  });
}

function defaultConfig(): RequestInit {
  return {
    credentials: 'include',
  };
}

export const preflightApiClient = createHttpClient(
  `${process.env.NEXT_PUBLIC_API_BASE_URL!}`,
  headers,
  defaultConfig,
);

export const createPreflightApiClient = (authToken: string) =>
  createHttpClient(
    `${process.env.NEXT_PUBLIC_API_BASE_URL!}`,
    headersSSR(authToken),
    defaultConfig,
  );
